import * as React from "react";
import { cn } from "@babackapp/customer-ui/lib/utils";

interface CustomerUiProviderProps {
  children?: React.ReactNode;
  className?: string;
  colors?: {
    primary?: string;
  };
  fonts?: {
    sans?: string;
  };
  customCssUrl?: string;
}

export function CustomerUiProvider({ children, className, colors, fonts, customCssUrl }: CustomerUiProviderProps) {
  // Inject shop-level theme overrides as a stylesheet so they sit below
  // the unlayered merchant custom CSS in the cascade (source order wins).
  const shopStyles = buildShopStyles({ colors, fonts });

  React.useEffect(() => {
    if (!shopStyles) return;
    const style = document.createElement("style");
    style.setAttribute("data-baback-shop-theme", "");
    style.textContent = shopStyles;
    document.head.appendChild(style);
    return () => style.remove();
  }, [shopStyles]);

  React.useEffect(() => {
    if (!customCssUrl) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = customCssUrl;
    document.head.appendChild(link);
    return () => link.remove();
  }, [customCssUrl]);

  return (
    <div className={cn("cui", className)}>
      {children}
    </div>
  );
}

function buildShopStyles({ colors, fonts }: Pick<CustomerUiProviderProps, "colors" | "fonts">): string | null {
  const vars: string[] = [];
  if (colors?.primary) vars.push(`--primary: ${colors.primary};`);
  if (fonts?.sans) vars.push(`--font-sans: ${fonts.sans};`);
  if (vars.length === 0) return null;
  return `@layer baback-shop { :root { ${vars.join(" ")} } }`;
}
